<div class="container-fluid pe-5">
  @if (show) {
    <div class="sub-nav-container">
      <app-cart></app-cart>
    </div>
  }
</div>
